import React, { Fragment, useEffect, useState } from 'react';
import {
    Alert,
    Button,
    Card,
    CardBody,
    CardHeader,
    CardText,
    Col,
    Input,
    Nav,
    NavItem,
    NavLink,
    Progress,
    Row,
    Spinner,
    TabContent,
    Table,
    TabPane
} from "reactstrap";
import axios from "axios";
import { AlertCircle, CheckCircle, Clock, Download, XCircle } from "react-feather";

// ** Third Party Components
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
// styles import
import '@styles/react/libs/file-uploader/file-uploader.scss'
import { useParams } from "react-router-dom";
import SignFormWizard from "./components/sign-form-wizard";

import '@styles/react/libs/react-select/_react-select.scss'
import pdf from "@src/assets/images/pdf.png"
import RubriDoc from "@src/assets/images/logo/RubriDoc.png"
import crediq from "@src/assets/images/logo/crediq.png"
import moment from "moment/moment";
import styles from "./components/styles.module.scss";
import PDFViewer from "./components/pdf-viewer";
import { display, margin } from '@mui/system';
import FullPageSpinner from '../../../@core/components/spinner/Full-page-spinner';
import { saveAs } from 'file-saver';

const MySwal = withReactContent(Swal)

const DownloadInvoices = () => {

    const params = useParams();
    const [loading, setLoading] = useState(false);
    const [isDownload, setIsDownload] = useState(false);
    const [locationData, setLocationData] = useState({});
    const [mobile, setMobile] = useState(false);
    // habilita o deshabilita la pantalla de los terminos y condiciones
    const [showTC, _] = useState(true);
    const [finishTYC, setFinishTYC] = useState(false);
    const [checks, setChecks] = useState([]);

    const [documents, setDocuments] = useState([]);
    const [pdfActive, setPdfActive] = useState(0);
    const [expireDate, setExpireDate] = useState('');
    const [expirePage, setExpirePage] = useState(false)

    const [clientInfo, setClientInfo] = useState(null);
    const [clientIp, setClientIp] = useState(null);

    const [permitLocation, setPermitLocation] = useState(false);
    const [coordinates, setCoordinates] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_SERVICE_URL || "https://firma.rubridoc.com/api"


    useEffect(() => {
        if (expirePage) {
            localStorage.clear();
        }
    }, [expirePage])

    const calculateLocation = async (latitude, longitude) => {
        const MAPS_API_KEY="664815a22ee9e493682149byqea0943"
        let dataLocation = {
            latitude,
            longitude,
        };
        try {
            const requestLocationGeo = await axios.get(`https://geocode.maps.co/reverse?api_key=${MAPS_API_KEY}&lat=${latitude}&lon=${longitude}`);
            const responseLocation = requestLocationGeo.data.address;
            const restDataLocation = {
                road: responseLocation.road || null,
                city: responseLocation.city || responseLocation.municipality || responseLocation.county || responseLocation.town || null,
                country: responseLocation.country,
                region: responseLocation.state || responseLocation.region,
            };
            dataLocation = {
                ...dataLocation,
                rest: restDataLocation
            };
            setLocationData(dataLocation);
        } catch (e) {
            const requestLocationNom = await axios.get(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`);
            const responseLocation = requestLocationNom.data.address;
            const restDataLocation = {
                road: responseLocation.road || null,
                city: responseLocation.city || responseLocation.municipality || responseLocation.county || responseLocation.town || null,
                country: responseLocation.country,
                region: responseLocation.state || responseLocation.region || null
            };
            dataLocation = {
                ...dataLocation,
                rest: restDataLocation
            };
            setLocationData(dataLocation);
        }
    }

    useEffect(() => {
        if (permitLocation && coordinates) {
            const latitude = coordinates.latitude;
            const longitude = coordinates.longitude;
            calculateLocation(latitude, longitude);
        }
    }, [permitLocation]);

    const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
    };

    const getPosition = (data) => {
        if (data) {
            setCoordinates({
                latitude: data.coords.latitude,
                longitude: data.coords.longitude
            })
            setPermitLocation(true);
        }
    };

    const error = (err) => {
        console.warn(`ERROR(${err.code}): ${err.message}`);
    }

    const toggleDocument = tab => {
        setPdfActive(tab)
    }

    const expireDateRequest = async () => {
        const result = await axios.post(
            `${process.env.REACT_APP_API_URL}/documents/getClaimsToken`,
            {
                token: params.token
            });
        setExpireDate(result.data.expires);
        setExpirePage(result.data.expired);
    }

    const generateDocuments = async (documentsAwsId, documentsNames) => {
        const headers = new Headers({
            Authorization: `Bearer ${params.token}`,
            'Content-Type': 'application/json',
        });

        const requestsByTitle = documentsAwsId.map((awsId, idx) => {
            const documentTitle = documentsNames[idx];
            const clientName = params.clientName;

            const encodedTitle = encodeURIComponent(documentTitle);
            const encodedClientName = encodeURIComponent(clientName);
            const url = `${process.env.REACT_APP_API_URL}/documents/getDocumentByTitle/${encodedTitle}-${encodedClientName}-${awsId}`;
            
            return fetch(url, {method: 'GET', headers})
                .then(response => response.json())
                .then(list => list[0])
        });

        const documentsByTitle = await Promise.all(requestsByTitle);
        const requestsDocuments = documentsByTitle.map(doc => {
            const id = doc.id;
            const title = doc.title;
            const url = `${process.env.REACT_APP_API_NODE_URL}/document/${params.clientName}/${title}/${id}`;

            return fetch(url, {method: 'GET', headers})
            .then(response => response.json());
        });
        
        const documentsResult = await Promise.all(requestsDocuments);
        setDocuments(documentsResult);
        setLoading(false);
    }

   /* useEffect(() => {
        navigator.geolocation.getCurrentPosition(getPosition, error, options);
        const documentsAwsId = params.documentAwsId.split(',');
        const documentsNames = params.documentNames.split(',');
        if (documentsAwsId.length) {
            setLoading(true);
            generateDocuments(documentsAwsId, documentsNames);
        }
        expireDateRequest();
    }, []);**/

    const getBigDataCloud = async () => {
      try {
          const baseUrlCloud = 'https://api-bdc.net/data';
  
          // Llamada a client-info
          const dataResultClient = await axios.get(`${baseUrlCloud}/client-info`);
          setClientInfo(dataResultClient.data);
      } catch (error) {
          console.error("Error al obtener client-info:", error);
          setClientInfo(null); // O establece un valor predeterminado si es necesario
      }
  
      try {
          // Llamada a client-ip
          const dataResultIp = await axios.get('https://api.bigdatacloud.net/data/client-ip');
          setClientIp(dataResultIp.data);
      } catch (error) {
          console.error("Error al obtener client-ip:", error);
          setClientIp(null); // O establece un valor predeterminado si es necesario
      }
  };

    useEffect(() => {
      if (!clientInfo || !clientIp) {
        getBigDataCloud();
      }
    }, [finishTYC, checks]);

    const getUrlDocumentSigned = results =>
        results
            .map(result => `<a href="${result.documentUrl}" target="_blank" download>${result.documentName}</a>`)
            .join('<br>');

    const MAX_SIGN_ATTEMPTS = 15;

    const sign = async (event, attempt = 1) => {
        setLoading(true);

        const results = [];

        try {
            await Promise.all(checks.map(async (item) => {
                let location = null;
                if (permitLocation) {
                    location = Object.values(locationData.rest).filter(x => x).join(', ');
                }

                const data = {
                    client_id: localStorage.getItem("client-document"),
                    signer_name: localStorage.getItem("client-name"),
                    client_name: params.clientName,
                    document_id: item.id,
                    document_name: item.documentName,
                    document_size: item.documentSize,
                    ip: clientIp.ipString || '0.0.0.0',
                    os: clientInfo.os ? `${clientInfo.os}` : null,
                    device_model: clientInfo.userAgentDisplay ? `${clientInfo.userAgentDisplay}` : null,
                    browser: clientInfo.userAgent ? `${clientInfo.userAgent}` : null,
                    location,
                    lat_long: locationData.latitude ? `${locationData.latitude}, ${locationData.longitude}` : null,
                    language: clientInfo.userLanguages?.length ? clientInfo.userLanguages[0] : 'en',
                    device: clientInfo.device ? clientInfo.device : null,
                };

                try {
                    const res = await fetch(`${process.env.REACT_APP_API_NODE_URL}/sign/document`, {
                        method: 'POST',
                        headers: {
                            Authorization: `Bearer ${params.token}`,
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(data)
                    }).then(response => response.json());

                    results.push(res);
                } catch (err) {
                    const errorMessage = err.message ?? 'Tiempo de solicitud excedido'
                    throw new Error(errorMessage);
                }
            }));

            await fetch(`${process.env.REACT_APP_API_URL}/documents/signedDocumentNotification`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${params.token}`,
                    'Content-Type': 'application/json',
                },
            });

            // Muestra el modal con todos los documentos al final del bucle
            await MySwal.fire({
                title: 'Descargado',
                html: `Haga click si desea descargar el documento: <br> <br> 
                        ${getUrlDocumentSigned(results)}`,
                icon: 'success',
                confirmButtonText: 'Finalizar',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                allowEscapeKey: false,
                allowOutsideClick: false
            });

            // Actualiza la página después de confirmar
            window.location.reload();
        } catch (err) {
            if (attempt < MAX_SIGN_ATTEMPTS) {
                await new Promise(resolve => setTimeout(resolve, 1000)); // Espera 1 segundo
                sign(event, attempt + 1);
            } else {
                await MySwal.fire({
                    title: 'Error al descargar el documento',
                    html: `Esto ha tomado más de lo esperado. </br> Inténtelo nuevamente.`,
                    icon: 'danger',
                    showCloseButton: false,
                    showCancelButton: false,
                    confirmButtonText: 'Intentarlo de nuevo',
                    customClass: {
                        confirmButton: 'btn btn-danger'
                    },
                    buttonsStyling: false,
                    allowEscapeKey: false,
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        setLoading(false);
                        sign(event);
                    }
                });
            }
        }
    };

    const rejectDocument = async () => {
        const { value: text } = await MySwal.fire({
            title: 'Desea solicitar cambio?',
            input: 'textarea',
            inputLabel: 'Razón de solicitud de cambio?',
            inputPlaceholder: 'Agrega un comentario...',
            inputAttributes: {
                'aria-label': 'Escribe tu comentario aqui',
                'style': 'margin: 20px;'
            },
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    if (value.trim() !== '') {
                        resolve()
                    } else {
                        resolve('La razón es obligatoria')
                    }
                })
            },
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Enviar',
            cancelButtonText: 'Cancelar',
            customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-outline-primary ms-1'
            },
            buttonsStyling: false
        });

        if (text) {
            setLoading(true);

            checks.forEach((item, index) => {

                const data = {
                    client_id: localStorage.getItem("client-document"),
                    company_name: params.clientName,
                    document_name: item.documentName,
                    document_id: item.id,
                    observation: text
                }
                const resultDocument = async () => {
                    return await axios.post(
                        `${process.env.REACT_APP_API_NODE_URL}/reject/document`,
                        data);
                }

                resultDocument().then(async res => {

                    if (res.data.documentName) {
                        await MySwal.fire({
                            title: 'Documento Rechazado',
                            html: `Documento ${res.data.documentName} se ha rechazado. <span style="display: block; position: relative; margin-top: 10px">
                        <b>Causa: </b> ${text}
                        </span> <hr>`,
                            icon: 'warning',
                            showCloseButton: false,
                            showCancelButton: false,
                            confirmButtonText: 'Finalizar',
                            customClass: {
                                confirmButton: 'btn btn-warning'
                            },
                            buttonsStyling: false,
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        }).then((result) => {
                            if (result.isConfirmed && index + 1 === checks.length) {
                                window.location.reload()
                            }
                        })
                    } else {
                        await MySwal.fire({
                            title: 'Error al rechazar el documento',
                            html: `El documento no se ha logrado rechazar. <span style="display: block; position: relative; margin-top: 10px">
                        <b>Causa: </b> ${res.data.resultStatusDocument}
                        </span> <hr>`,
                            icon: 'danger',
                            showCloseButton: false,
                            showCancelButton: false,
                            confirmButtonText: 'Aceptar',
                            customClass: {
                                confirmButton: 'btn btn-danger'
                            },
                            buttonsStyling: false,
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        }).then((result) => {
                            if (result.isConfirmed) {
                                setLoading(false);
                                window.location.reload();
                            }
                        })
                    }
                }).catch(async err => {

                    await MySwal.fire({
                        title: 'Error al rechazar el documento',
                        html: `El documento no se ha logrado rechazar. <span style="display: block; position: relative; margin-top: 10px">
                        <b>Causa: </b> ${err.data}
                        </span> <hr>`,
                        icon: 'danger',
                        showCloseButton: false,
                        showCancelButton: false,
                        confirmButtonText: 'Aceptar',
                        customClass: {
                            confirmButton: 'btn btn-danger'
                        },
                        buttonsStyling: false,
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setLoading(false);
                            window.location.reload();
                        }
                    })
                })
            })
        }
    }

    const fetchDocumentData = async () => {
        try {
          // Crear una instancia de axios sin interceptores
          const uninterceptedAxiosInstance = axios.create();
    
          // Realizar la llamada a la API
          const documentResult = await uninterceptedAxiosInstance.get(
            `${BASE_URL}/transaction/file/pdf/${params.documentId}`,
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${params.token}`
              }
            }
          );

          console.log("documentResult: ", documentResult)
        } catch (error) {
          // Manejo de errores
          console.error("Error fetching client data: ", error);
        }
      };

    useEffect(() => {
        //fetchDocumentData()
    }, [params.documentId])

    const downloadPDF = async () => {
      try {
          const uninterceptedAxiosInstance = axios.create();
          const response = await uninterceptedAxiosInstance.get(`${BASE_URL}/transaction/file/pdf/${params.documentId}`, {
              headers: {
                  'Accept': 'application/json, text/plain, */*',
                  'Authorization': `Bearer ${params.token}`
              },
              responseType: 'arraybuffer'
          });
  
          // Crear un blob de la respuesta
          const blob = new Blob([response.data], { type: 'application/pdf' });
  
          // Usar FileSaver para descargar el archivo
          saveAs(blob, `${params.documentId}.pdf`); // Nombre del archivo
      } catch (error) {
          console.error('Error al descargar el PDF:', error);
      }
    };

    const downloadJSON = async () => {
      try {
          //setIsDownload(true);
          const uninterceptedAxiosInstance = axios.create();
          const apiResponse = await uninterceptedAxiosInstance.get(`${BASE_URL}/transaction/file/json/${params.documentId}`, {
              headers: {
                  'Accept': 'application/json, text/plain, */*',
                  'Authorization': `Bearer ${params.token}`
              },
          });

          // Crear un blob con los datos JSON
          const blob = new Blob([apiResponse.data], { type: 'application/json' });

          // Usar FileSaver para descargar el archivo
          saveAs(blob, `${params.documentId}.json`);
          //setIsDownload(false);

      } catch (error) {
          //setIsDownload(false);
          console.error('Error al descargar el JSON:', error);
      }
    };


    const handleDownloadDocuments = async () => {
      try {
        await Promise.all([/*downloadPDF()*/downloadJSON()]);
      } catch (error) {
        console.error('Error al descargar documentos:', error);
      }
    };

    return (
      <Fragment>
        {/* { isDownload && <FullPageSpinner message="Descargando documentos..."/>} */}
        
        {loading && (
          <div className="row">
            <div className="col-12 px-2 py-4 text-center">
              <Spinner size="lg" />
              <CardText className={"py-1 fs-5"}>Cargando...</CardText>
            </div>
          </div>
        )}

        {!loading && expirePage && (
          <Row className={"justify-content-center"}>
            <Col
              style={{
                paddingTop: "15%",
              }}
              md="8"
              sm="12"
              className={"px-5"}
            >
              <Card>
                <CardBody className="p-5 text-center">
                  <Clock size="32" className="mb-1" />
                  <h2 className="mb-1 fw-bolder">URL ha expirado!</h2>
                  <CardText
                    style={{
                      fontSize: "18px",
                    }}
                  >
                    Estimad@ cliente, su enlace a expirado, favor comuníquese
                    con su ejecutivo para enviárselo nuevamente.
                    <br />
                    ¡Gracias por escoger a CREDIQ!
                  </CardText>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {!loading &&
          !finishTYC /*&& !expirePage && !finishTYC && documents.length*/ && (
            <Row>
              <SignFormWizard
                handleFinish={setFinishTYC}
                token={params.token}
                showTC={showTC}
                ids={params?.documentAwsId}
                client={params?.clientName}
                setMobile={setMobile}
                mobile={mobile}
                docId={params.documentId}
              />
            </Row>
          )}

        {!loading &&
          finishTYC /*&& !expirePage && finishTYC && documents.length*/ && (
            <div className="row">
              <div className="col-12 px-2 py-1">
                <Card>
                  <CardHeader>
                    <h2>Descargar Documentos</h2>
                  </CardHeader>
                  <CardBody>
                    <CardText>
                      Previsualiza la información y descarga este documento
                    </CardText>

                    <Row className="">
                      <Col
                        className="pt-2"
                        md={{ size: 5, order: 1 }}
                        xs={{ size: 12, order: 1 }}
                      >
                        <Row>
                          <Col
                            md={{ size: 7, order: 0 }}
                            xs={{ size: 6, order: 0 }}
                          >
                            <h3 className={"pb-1"}>Instrucciones</h3>
                            <hr />
                          </Col>

                          <Col
                            md={{ size: 5, order: 1 }}
                            xs={{ size: 6, order: 1 }}
                          >
                            <img
                              src={crediq}
                              className={"ps-2 text-end"}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "39px",
                                float: "right",
                              }}
                              alt={"crediq"}
                            />
                          </Col>
                        </Row>

                        <Col
                          md={{ size: 12, order: 1 }}
                          xs={{ size: 12, order: 1 }}
                        >
                          <div className={"py-1"}>
                            <p>Por favor siga las siguientes instrucciones: </p>
                            <ul>
                              <li
                                className={`${styles.textJustify} pt-1 d-none`}
                              >
                                Previo haber sido identificado con el
                                procedimiento de identificación anterior y
                                registro de mi prueba de vida, declaro haber
                                leído cada uno de los documentos que se
                                suscriben, marcando cada uno en señal de
                                aceptación de las condiciones contenidas en los
                                mismos
                              </li>
                              <li className={`${styles.textJustify} pt-1`}>
                                Seleccione el botón descargar json, para descargar el documento fiscal oficial.
                              </li>
                              <li className={`${styles.textJustify} pt-1`}>
                                Seleccione <Download size={16}/> para descargar la representación gráfica del documento.
                              </li>
                            </ul>

                            <Table className={"my-2"} borderless responsive style={{display: "none"}}>
                              <thead>
                                <tr>
                                  <th width={"20%"}>Seleccione</th>
                                  <th width={"80%"}>Documento</th>
                                </tr>
                              </thead>
                              <tbody>
                                <Fragment>
                                    <tr>
                                      <td className={"text-center"}>
                                        <CardText className="form-check form-check-inline text-center cursor-pointer">
                                          <Input
                                            className={"cursor-pointer"}
                                            type="checkbox"
                                            defaultChecked={false}
                                            onChange={(e) => {
                                              if (e.target.checked) {
                                                setChecks((old) => [
                                                  ...old,
                                                  {
                                                    id: document.id,
                                                    documentName:
                                                      document.documentName,
                                                    documentSize: document.size,
                                                  },
                                                ]);
                                              } else {
                                                setChecks(
                                                  checks.filter(
                                                    (a) =>
                                                      a.documentName !==
                                                      document.documentName
                                                  )
                                                );
                                              }
                                            }}
                                          />
                                        </CardText>
                                      </td>
                                      <td className={"cursor-pointer"}>
                                        <div
                                          className={
                                            "cursor-pointer text-capitalize"
                                          }
                                          onClick={() => setPdfActive(index)}
                                        >
                                          <img
                                            className="me-75"
                                            src={pdf}
                                            alt={document.name}
                                            height="20"
                                            width="20"
                                          />
                                          {document.name
                                            ?.toString()
                                            .replaceAll(".pdf", "")}
                                        </div>
                                      </td>
                                    </tr>

                                  {/*document.status === 2 && (
                                    <tr>
                                      <td className={"text-center"}>
                                        <CardText className="form-check form-check-inline text-center">
                                          <Input
                                            type="checkbox"
                                            defaultChecked={false}
                                            disabled
                                          />
                                        </CardText>
                                      </td>
                                      <td>
                                        <div
                                          className={
                                            "text-capitalize text-muted"
                                          }
                                          onClick={() => setPdfActive(index)}
                                        >
                                          <img
                                            className="me-75"
                                            src={pdf}
                                            alt={document.name}
                                            height="20"
                                            width="20"
                                          />
                                          {document.name
                                            ?.toString()
                                            .replaceAll(".pdf", "")}
                                          (descargado)
                                        </div>
                                      </td>
                                    </tr>
                                  )*/}
                                </Fragment>

                                {/*documents.filter((a) => a.status === 2)
                                  .length === documents.length && (
                                  <tr>
                                    <td colSpan={2}>
                                      <span
                                        className={
                                          "d-block p-3 m-0 m-auto text-center"
                                        }
                                      >
                                        No hay documentos para descargar!
                                      </span>
                                    </td>
                                  </tr>
                                )*/}
                              </tbody>
                            </Table>
                          </div>
                        </Col>

                        <Col
                          md={{ size: 12, order: 2 }}
                          xs={{ size: 12, order: 2 }}
                        >
                          <hr />
                          <div className="pb-2 d-flex justify-content-center" style={{display: "flex"}}>
                            <Button
                              type="button"
                              color="warning"
                              outline
                              onClick={handleDownloadDocuments}
                              className={"me-75"}
                            >
                              Descargar JSON
                            </Button>
                            <Button
                              type="button"
                              color="primary"
                              onClick={handleDownloadDocuments}
                              style={{display: "none"}}
                              className={"me-75"}
                            >
                              Descargar documentos relacionados
                            </Button>
                          </div>
                        </Col>

                        <Col
                          md={{ size: 12, order: 2 }}
                          xs={{ size: 12, order: 2 }}
                        >
                          <img
                            src={RubriDoc}
                            style={{
                              height: "40px",
                              position: "absolute",
                              bottom: "25px",
                              right: "25px",
                            }}
                            className={"text-center m-auto"}
                            alt={"rubridoc"}
                          />
                        </Col>
                      </Col>
                      <Col
                        className="pt-2"
                        md={{ size: 7, order: 2 }}
                        xs={{ size: 12, order: 2 }}
                      >
                        <Nav pills>
                          {documents.map((document, index) => {
                            return (
                              <NavItem key={index}>
                                <NavLink
                                  active={pdfActive === index}
                                  onClick={() => {
                                    toggleDocument(index);
                                  }}
                                >
                                  {document.name
                                    ?.toString()
                                    .replaceAll(".pdf", "")}
                                </NavLink>
                              </NavItem>
                            );
                          })}
                        </Nav>
                        <TabContent className="py-50">
                          <PDFViewer
                            isActive={true}
                            url={`${BASE_URL}/transaction/file/pdf/${params.documentId}`}
                            token={params.token}
                            style={{
                              display: "inline-flex",
                              height: mobile ? "480px" : "1065px",
                              width: "100%",
                            }}
                            isPdfDownload={true}
                          />
                        </TabContent>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </div>
            </div>
          )}
      </Fragment>
    );
};

export default DownloadInvoices;
